import { MutableRefObject } from 'react';

const OneDay = ({
  oneDayContentElem,
  oneDayMobileImg,
}: {
  oneDayContentElem: MutableRefObject<HTMLDivElement>;
  oneDayMobileImg: MutableRefObject<HTMLDivElement>;
}) => {
  return (
    <div className="for-lawyer__oneday-content" ref={oneDayContentElem}>
      <div className="for-lawyer__oneday-content-center">
        <div className="for-lawyer-oneday-device-img" ref={oneDayMobileImg}></div>
        <div className="for-lawyer-dayplus-title view-on-visible">
          <h2 className="for-lawyer-day-title">Day</h2>
          <span className="for-lawyer-day-plus-number-title">+1</span>
        </div>
        <p className="for-lawyer-day-desc view-on-visible">
          한 줄 소개, 사무실 정보, 주요 분야 등&nbsp;
          <span className="for-lawyer-day-desc-bold">의뢰인에게 소개할 내 프로필을 입력</span>한다. 방문 상담과 서면,
          계약서 작성 등 서비스 요금과 수임료 정보를 입력했다.
        </p>
        <div className="for-lawyer__slide-circle-container">
          <div className="for-lawyer__slide-circle active" />
          <div className="for-lawyer__slide-circle" />
          <div className="for-lawyer__slide-circle" />
        </div>
      </div>
    </div>
  );
};

export default OneDay;
